import { v3Url } from '@/utils/fetcher';
import { useAxios } from '../base/useAxios';

export default function useCommsAuthActions() {
  const api = useAxios();

  return {
    disconnectCommsAuth(id) {
      return api.delete(v3Url(`comms/auth/${id}`));
    },
  };
}
